// Import the ESM build explicitly. @glidejs/glide 3.7.x sets `"type": "module"`, so bundlers
// parse the UMD file behind its `require` condition (dist/glide.js) as ESM - the UMD wrapper's
// `module.exports` branch is then dead code and the module exports nothing, leaving the default
// import undefined ("glide_1.default is not a constructor").
import Glide from '@glidejs/glide/dist/glide.esm.js'

export class GlideSlider {
    duration: number;
    transition: number;
    class: string;
    transitionType: string;
    constructor(options: { class: string; duration?: number; transition?: number; type?:string }) {
        this.class = options.class
        this.duration = options.duration || 0
        this.transition = options.transition || 0
        this.transitionType = options.type || ''
        this.init()
    }

    init() {
        const glide = new Glide(`.${this.class}`, {
            perView: 1,
            type: 'carousel',
            autoplay: this.duration > 0 ? this.duration * 1000 : 'false',
            animationDuration: this.transition,
            hoverpause: true,
            rewindDuration: this.duration * 1000,
            gap: 0,
        });
        glide.on('mount.after', () => {
            this.addHeightAttrToSlide()
        })
        this.addTransitiomType(glide, this.transitionType);
        glide.mount();
        window.addEventListener('resize', () => {
            this.addHeightAttrToSlide()
        })
    }
    elementStyle(element, style){
        return parseFloat(window.getComputedStyle(element).getPropertyValue(style));
    }

    /*
     * Calculate the height of the slider
     * Is based on the height of the highest slider  
     */
    addHeightAttrToSlide() {
        const slides = document.querySelectorAll(`.${this.class} .slide`);
        const slidesContent = document.querySelectorAll(`.${this.class} .slide .slide-content`);
        const heights = Array.from(slidesContent).map((i) => {
            const textArea = i.querySelector('.text-area');
            const imageArea = i.querySelector('.image-area');
            const paddingY = i.querySelector('.text-area')
                ? this.elementStyle(textArea, 'padding-top') + this.elementStyle(textArea, 'padding-bottom')
                : this.elementStyle(imageArea, 'padding-top') + this.elementStyle(imageArea, 'padding-bottom')

            let height;
            const checkDocWidth = (firstBlock: number, secoundBlock: number): number => {
                return window.innerWidth <= 640
                    ? firstBlock + secoundBlock
                    : firstBlock
            }
            const textBlock = textArea.querySelector('.block');
            const imageBlock = imageArea.querySelector(' img');
            if (textBlock && imageBlock) {
                height = textBlock.clientHeight > imageBlock.clientHeight
                    ? checkDocWidth(textBlock.clientHeight, imageBlock.clientHeight)
                    : checkDocWidth(imageBlock.clientHeight, textBlock.clientHeight);
            } else if (textBlock && !imageBlock) {
                height = textBlock.clientHeight;
            } else if (!textBlock && imageBlock) {
                height = imageBlock.clientHeight
            } else {
                height = i.clientHeight
            }
            return height + paddingY;
        }).sort((a, b) => b - a);
        const glideSlider = document.querySelector(`.${this.class}`);
        if (glideSlider && glideSlider.classList.contains('fade')) {
            slides.forEach(i => {
                i['style'].height = `${heights[0]}px`;
            })
        }
       
    };

    /*
     * Adds a transition type to the slider
     */
    addTransitiomType(slider, type: string) {
        switch (type) {
            case 'fade':
                document.querySelector(`.${this.class}`).classList.add(type);
                const slides = document.querySelectorAll(`.${this.class} .slide`);
                if (slides && slides.length > 0) {
                    slides.forEach(slide => slide['style'].transition = ` opacity ${this.transition}ms ease-in-out`)
                }
                
                break;
            case 'slide':
                if (document.querySelector(`.${this.class}`).classList.contains('fade')) {
                    document.querySelector(`.${this.class}`).classList.remove('fade');
                }
                slider.update({ animationDuration: Number(this.transition) })
                break;
            default:
                slider.update({ animationDuration: 0 })
                break;
        }
    }

   
}